<template>
  <i18n-t
    :keypath="
      type === 'with-prize'
        ? 'scratchcard.freeticket.text.withprize'
        : 'scratchcard.freeticket.text.withoutprize'
    "
    :plural="freeTickets"
    scope="global"
  >
    <template #ticket>
      <span :class="ticketClass">
        {{
          $t('scratchcard.freeticket.text.ticket', {
            count: freeTickets,
          })
        }}
      </span>
    </template>
  </i18n-t>
</template>

<script lang="ts" setup>
type Props = {
  freeTickets: number
  ticketClass?: string
  type?: 'free-ticket-only' | 'with-prize'
}

const { ticketClass, type = 'free-ticket-only' } = defineProps<Props>()
</script>
